import { useBetterVModel as e } from "../../../../composables/useBetterVModel.js";
import { useRealProps as t } from "../../../../composables/useRealProps.js";
import { useSlotsExists as n } from "../../../../composables/useSlotsExists.js";
import { SmartRenderer as r, resolveVNode as i } from "../../../../lib/utils.js";
import { Slot as a } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/Primitive/Slot.js";
import o from "../core/TooltipContent.js";
import s from "../core/TooltipProvider.js";
import c from "../core/TooltipTrigger.js";
import { TOOLTIP_OPEN_MODEL_VALUE_KEY as l } from "../injectionKeys.js";
import u from "./TooltipBind.js";
import { createBlock as d, createCommentVNode as f, createVNode as p, defineComponent as m, guardReactiveProps as h, normalizeProps as g, openBlock as _, provide as v, renderSlot as y, unref as b, useAttrs as x, withCtx as S } from "vue";
//#region src/components/ui/tooltip/wrapper/TooltipWrapper.vue?vue&type=script&setup=true&lang.tsx
var C = /* @__PURE__ */ m({
	__name: "TooltipWrapper",
	props: {
		content: { type: [
			Object,
			String,
			Number,
			Boolean,
			null,
			Array,
			Function
		] },
		placement: {},
		reference: {},
		open: { type: Boolean },
		defaultOpen: { type: Boolean },
		usedInDirectives: { type: Boolean }
	},
	emits: ["update:open"],
	setup(m, { emit: C }) {
		let w = m, T = C, E = x(), D = e({
			props: w,
			realProps: t(),
			key: "open",
			defaultValue: w.defaultOpen
		}), O = n(["default", "content"]);
		v(l, D);
		function k(e) {
			T("update:open", e);
		}
		return (e, t) => (_(), d(s, null, {
			default: S(() => [p(u, {
				"used-in-directives": w.usedInDirectives,
				open: w.open,
				"default-open": w.defaultOpen,
				"handle-tooltip-open-update": k
			}, {
				default: S(() => [p(c, {
					"as-child": "",
					reference: w.reference
				}, {
					default: S(() => [p(b(a), g(h(b(E))), {
						default: S(() => [y(e.$slots, "default")]),
						_: 3
					}, 16)]),
					_: 3
				}, 8, ["reference"]), b(O).content || w.content ? (_(), d(o, {
					key: 0,
					side: w.placement
				}, {
					default: S(() => [y(e.$slots, "content", {}, () => [p(b(r), { children: b(i)(w.content) }, null, 8, ["children"])])]),
					_: 3
				}, 8, ["side"])) : f("", !0)]),
				_: 3
			}, 8, [
				"used-in-directives",
				"open",
				"default-open"
			])]),
			_: 3
		}));
	}
});
//#endregion
export { C as default };

//# sourceMappingURL=TooltipWrapper_vue.js.map